export default function ErrorMessege(){
    return<p className="ErrorMessege">
        Proszę obrócić urządzenie, aby kontynuować. 
    </p>
}